import type { SVGProps } from 'react';

const SvgFeatured = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
    <path
      fill={props.color}
      fillRule="evenodd"
      d="M16.202.95c.3 0 .573.17.705.438l4.285 8.672.006.014a.98.98 0 0 0 .75.553h.003l9.567 1.394a.787.787 0 0 1 .436 1.342L25.04 20.11a1.02 1.02 0 0 0-.305.917l1.643 9.525a.787.787 0 0 1-1.142.83l-8.548-4.492-.013-.007a.98.98 0 0 0-.946 0l-.014.007-8.547 4.492a.787.787 0 0 1-1.142-.829l1.624-9.538a1 1 0 0 0-.29-.909l-.005-.004L.43 13.364a.787.787 0 0 1 .435-1.343l9.567-1.393h.003a1.02 1.02 0 0 0 .775-.565l.002-.003 4.284-8.672a.79.79 0 0 1 .706-.439m-3.577 9.803-.001.002a2.6 2.6 0 0 1-1.967 1.43h-.002L2.671 13.35l5.777 5.621.003.003a2.58 2.58 0 0 1 .747 2.326l-1.354 7.95 7.133-3.749a2.56 2.56 0 0 1 2.45 0l7.128 3.747-1.371-7.953a2.6 2.6 0 0 1 .77-2.323l5.761-5.622-7.988-1.163h-.001a2.55 2.55 0 0 1-1.949-1.435l-3.575-7.238z"
      clipRule="evenodd"
      data-name="featured"
    />
  </svg>
);

export default SvgFeatured;
